import React from 'react';

export const LongArrowRightSvg: React.FC<React.SVGProps<SVGSVGElement>> = () => (
  <svg
    width="51"
    height="50"
    viewBox="0 0 51 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_3030_47426)">
      <path
        d="M50.1695 24.1982L38.8062 12.8347C38.398 12.3581 37.6806 12.3025 37.2039 12.7108C36.7273 13.119 36.6717 13.8364 37.08 14.313C37.1181 14.3575 37.1595 14.399 37.2039 14.4369L46.6242 23.8686H1.63631C1.00878 23.8686 0.5 24.3774 0.5 25.005C0.5 25.6326 1.00878 26.1413 1.63631 26.1413H46.6242L37.2039 35.5616C36.7273 35.9698 36.6717 36.6871 37.08 37.1638C37.4883 37.6404 38.2056 37.696 38.6822 37.2877C38.7267 37.2496 38.7682 37.2082 38.8062 37.1638L50.1696 25.8003C50.6102 25.3573 50.6102 24.6414 50.1695 24.1982Z"
        fill="currentColor"
      />
    </g>
  </svg>
);

export default LongArrowRightSvg;
